import { memberInitialData } from "../types/InitialData"

export type MemberTableType = {
  teamId: number
  userId: number
  firstName: string
  lastName: string
  user: string
  displayName: string
  username: string
  role: string
  email: string
  avatarUrl: string
  lastActivity: string
  licenses: []
  seatID: number
}

const convertToMemberReport = (data: memberInitialData): MemberTableType[] => {

  const members = data?.members ?? []

  const memberData = members.map(member => ({
    teamId: member.team_id ?? 0, // Replace 0 with appropriate default value
    userId: member.user_id ?? 0,
    firstName: member.first_name ?? '',
    lastName: member.last_name ?? '',
    user: member.full_name ?? '',
    displayName: member.display_name ?? '',
    username: member.username ?? '',
    role: member.role ?? '',
    email: member.email ?? '',
    avatarUrl: member.avatar_url ?? '',
    lastActivity: member.last_activity ?? '',
    licenses: member.licenses ?? [],
    seatID: member.seatID ?? 0
  }));

  return memberData;
  
}

export const MemberTableData = (data: memberInitialData): MemberTableType[] => {
  return convertToMemberReport(data)
}
